import type { ThemeComponentType } from '../types';

export const Divider: ThemeComponentType = {
  styles: (theme, { color }) => ({
    root: {
      '&': {
        borderTopColor: color || theme.colors.gray[2],
      },
    },
    label: {
      fontSize: theme.fontSizes.md,
      '&': {
        marginTop: 0,
      },
      ':before, :after': {
        borderTopColor: color || theme.colors.gray[2],
      },
    },
  }),
};
